declare global {
	interface Window {
		API_URL?: string;
	}
}

export const HTTP_HOST = window.API_URL ? window.API_URL : '/ecpp';
export const HOST = window.location.protocol + '//' + window.location.host;
